const Section = ({ children, className = '', id }) => {
  return (
    <section
      id={id}
      className={`py-16 sm:py-20 lg:py-24 ${className}`}
      aria-labelledby={id ? `${id}-title` : undefined}
    >
      {children}
    </section>
  );
};

export default Section;
